import { render, staticRenderFns } from "./transferlist.vue?vue&type=template&id=7989f349&scoped=true&"
import script from "./transferlist.vue?vue&type=script&lang=js&"
export * from "./transferlist.vue?vue&type=script&lang=js&"
import style0 from "./transferlist.vue?vue&type=style&index=0&id=7989f349&prod&lang=less&scoped=true&"
import style1 from "./transferlist.vue?vue&type=style&index=1&id=7989f349&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7989f349",
  null
  
)

export default component.exports